package org.example.project.screens_driver

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Style

@Composable
fun DriverAvatarCircle(
    imageSrc: String,
    offsetX: Double,
    offsetY: Double,
    zoom: String,
    initials: String = "",
    sizePx: Int = 128,
    onClick: (() -> Unit)? = null
) {
    Style(SharedDriverAvatarStyles)

    Div(attrs = {
        classes(SharedDriverAvatarStyles.avatarCircle)
        style {
            width(sizePx.px)
            height(sizePx.px)
        }
        if (onClick != null) {
            onClick { onClick() }
        }
    }) {
        Span({ classes(SharedDriverAvatarStyles.avatarInitials) }) {
            Text(initials.take(4).uppercase().ifBlank { "US" })
        }
    }
}

object SharedDriverAvatarStyles : StyleSheet() {
    val avatarCircle by style {
        borderRadius(50.percent)
        overflow("hidden")
        position(Position.Relative)
        property("background", "linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%)")
        property("border", "1px solid rgba(255,255,255,0.16)")
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        cursor("pointer")
        property("box-shadow", "0 18px 38px rgba(0,0,0,0.24)")
        property("flex-shrink", "0")
        padding(0.px)
        margin(0.px)
    }

    val avatarImage by style {
        position(Position.Absolute)
        left(50.percent)
        top(50.percent)
        maxWidth(100.percent)
        maxHeight(100.percent)
        property("width", "auto")
        property("height", "auto")
        property("object-fit", "contain")
        property("transform-origin", "center center")
        property("will-change", "transform")
    }

    val avatarPlaceholder by style {
        width(52.px)
        height(52.px)
        opacity(0.9)
        property("filter", "brightness(0) invert(1)")
    }

    val avatarInitials by style {
        color(Color.white)
        fontSize(34.px)
        fontWeight("700")
        lineHeight("1")
        textAlign("center")
        property("letter-spacing", "0.02em")
        property("text-shadow", "0 3px 12px rgba(0,0,0,0.30)")
    }
}
